import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { UsersComponent } from './users.component';
import { AuthGuard } from '../../services/auth-guard.service';
import { LoadingModule } from '../shared/controls/loading.component';
import { NotesModule } from '../shared/controls/notes.component';
import { LastUpdatedModule } from '../shared/controls/last-updated.component';

import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { UserListComponent } from './user-list.component';
import { SortIconCustomModule } from '../shared/controls/dynamic/sort-icon-custom.component';
import { DynamicValueModule } from '../shared/controls/dynamic/dynamic-value.component';
import { UserDetailComponent } from './user-detail.component';
import { ContactsDetailModule } from '../shared/controls/contacts-detail.component';
import { UserFormModule } from './user-form.component';
import { PaginatorCustomModule } from '../shared/controls/dynamic/paginator-custom.component';
import { KebobMenuModule } from '../shared/controls/dynamic/kebob-menu.component';
import { OrderFormModule } from '../orders/order-form.component';
import { RowToolsModule } from '../shared/controls/row-tools.component';
import { NotesDetailModule } from '../shared/controls/notes-detail.component';
import { LocationFormModule } from '../locations/location-form.component';


@NgModule({
  declarations: [
    UsersComponent,
    UserListComponent,
    UserDetailComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    NotesModule,
    DialogModule,
    LoadingModule,
    ButtonModule,
    LastUpdatedModule,
    SortIconCustomModule,
    DynamicValueModule,
    ContactsDetailModule,
    PaginatorCustomModule,
    KebobMenuModule,
    UserFormModule,
    OrderFormModule,
    RowToolsModule,
    NotesDetailModule,
    ConfirmDialogModule,
    LocationFormModule,
    RouterModule.forChild([
      {
        path: '',
        component: UsersComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: UserListComponent, canActivate: [AuthGuard] },
        ]
      }
    ])
  ],
  exports: [
    UsersComponent,
    UserDetailComponent,
  ]
})
export class UsersModule { }

